/// <reference lib="webworker" />
import * as pako from 'pako';

import {TypedWebWorker} from './typedWebWorker';

export const COMPRESS_VIEW_SPEC_REQUEST =
  'wandb/compressViewSpec/request' as const;
export const COMPRESS_VIEW_SPEC_RESULT =
  'wandb/compressViewSpec/result' as const;

export type CompressViewSpecRequest = {
  type: typeof COMPRESS_VIEW_SPEC_REQUEST;
  spec: unknown;
};

export type CompressViewSpecResult =
  | {
      type: typeof COMPRESS_VIEW_SPEC_RESULT;
      isSuccess: true;
      compressed: string | null;
    }
  | {
      type: typeof COMPRESS_VIEW_SPEC_RESULT;
      isSuccess: false;
      error: string;
    };

function compressSpec(specString: string): string | null {
  // Compress the spec string using gzip
  const compressed = pako.gzip(specString);

  // Convert the compressed data to a binary string in chunks
  let binaryString = '';
  const chunkSize = 0x8000; // 32KB
  for (let i = 0; i < compressed.length; i += chunkSize) {
    const chunk = compressed.subarray(i, i + chunkSize);
    binaryString += String.fromCharCode.apply(null, Array.from(chunk));
  }

  // Encode the binary string to base64
  const base64Encoded = btoa(binaryString);

  return base64Encoded;
}

class CompressViewSpecWebWorker extends TypedWebWorker<
  CompressViewSpecRequest,
  CompressViewSpecResult
> {
  protected readonly requestType = COMPRESS_VIEW_SPEC_REQUEST;
  protected readonly resultType = COMPRESS_VIEW_SPEC_RESULT;

  protected handle(request: CompressViewSpecRequest): CompressViewSpecResult {
    const {spec} = request;
    const specString = typeof spec === 'string' ? spec : JSON.stringify(spec);
    try {
      return {
        type: this.resultType,
        isSuccess: true,
        compressed: compressSpec(specString),
      };
    } catch (error) {
      return {
        type: this.resultType,
        isSuccess: false,
        error: (error as Error).message,
      };
    }
  }
}

export const compressViewSpecWebWorker = new CompressViewSpecWebWorker();

// Listen only when this file is running inside the worker.
compressViewSpecWebWorker.listenIfWorker();
